import { AnySourceStream, Stream } from '../stream'

export class StartWith<V, E = undefined, C = undefined> extends Stream<V, E, C> {
    protected source?: AnySourceStream<V, E, C>
    protected first = true
    protected start?: V

    constructor(start: V, source?: AnySourceStream<V, E, C>) {
        super()
        this.source = source
        this.start = start
    }

    connect() {
        super.connect()
        this.value(this.start!)
        if (this.source) this.source.subscribe(this)
    }

    disconnect() {
        super.disconnect()
        if (this.source) this.source.unsubscribe(this)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        startWith<NewValue>(start: NewValue): Stream<DV, DE, DC, DV | NewValue, DE, DC>
    }
}

Stream.prototype.startWith = function <V, E, C>(this: AnySourceStream<V, E, C>, start: V) {
    return new StartWith(start, this) // tslint:disable-line:no-invalid-this
}
